import { Icon, IconProps } from '@chakra-ui/react';

export const AddIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 5v14"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M5 12h14"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </Icon>
);

export const MinusIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M5 12h14"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </Icon>
);

export const DeleteIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 25" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 5.75C3 5.33579 3.33579 5 3.75 5H20.25C20.6642 5 21 5.33579 21 5.75C21 6.16421 20.6642 6.5 20.25 6.5H3.75C3.33579 6.5 3 6.16421 3 5.75Z"
      fill="#FF383C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 2.75C7.5 2.33579 7.83579 2 8.25 2H15.75C16.1642 2 16.5 2.33579 16.5 2.75C16.5 3.16421 16.1642 3.5 15.75 3.5H8.25C7.83579 3.5 7.5 3.16421 7.5 2.75Z"
      fill="#FF383C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.25 5C5.66421 5 6 5.33579 6 5.75V20H18V5.75C18 5.33579 18.3358 5 18.75 5C19.1642 5 19.5 5.33579 19.5 5.75V20C19.5 20.3978 19.342 20.7794 19.0607 21.0607C18.7794 21.342 18.3978 21.5 18 21.5H6C5.60218 21.5 5.22065 21.342 4.93934 21.0607C4.65804 20.7794 4.5 20.3978 4.5 20V5.75C4.5 5.33579 4.83579 5 5.25 5Z"
      fill="#FF383C"
    />
  </Icon>
);

export const VoucherIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 24" fill="none" {...props}>
    <mask
      id="mask0_6425_117710"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#8E8E93" />
    </mask>
    <g mask="url(#mask0_6425_117710)">
      <path
        d="M4.1999 19.1969C3.7049 19.1969 3.28115 19.021 2.92865 18.6691C2.57615 18.3173 2.3999 17.8944 2.3999 17.4004V14.3689C2.3999 14.2042 2.45349 14.0604 2.56065 13.9374C2.66782 13.8142 2.80557 13.7372 2.9739 13.7064C3.34124 13.5834 3.6374 13.3677 3.8624 13.0594C4.0874 12.751 4.1999 12.3969 4.1999 11.9969C4.1999 11.5969 4.0874 11.2427 3.8624 10.9344C3.6374 10.626 3.34124 10.4106 2.9739 10.2881C2.80557 10.2575 2.66782 10.1809 2.56065 10.0584C2.45349 9.93588 2.3999 9.79037 2.3999 9.62187V6.59212C2.3999 6.09846 2.57615 5.67587 2.92865 5.32437C3.28115 4.97271 3.7049 4.79688 4.1999 4.79688H19.7999C20.2949 4.79688 20.7187 4.97279 21.0712 5.32462C21.4237 5.67646 21.5999 6.09937 21.5999 6.59337V9.62488C21.5999 9.78954 21.5463 9.93337 21.4392 10.0564C21.332 10.1795 21.1942 10.2565 21.0259 10.2874C20.6586 10.4104 20.3624 10.626 20.1374 10.9344C19.9124 11.2427 19.7999 11.5969 19.7999 11.9969C19.7999 12.3969 19.9124 12.751 20.1374 13.0594C20.3624 13.3677 20.6586 13.5831 21.0259 13.7056C21.1942 13.7363 21.332 13.8129 21.4392 13.9354C21.5463 14.0579 21.5999 14.2034 21.5999 14.3719V17.4016C21.5999 17.8953 21.4237 18.3179 21.0712 18.6694C20.7187 19.021 20.2949 19.1969 19.7999 19.1969H4.1999ZM11.9947 16.1969C12.2482 16.1969 12.4624 16.1111 12.6374 15.9396C12.8124 15.7681 12.8999 15.5556 12.8999 15.3021C12.8999 15.0486 12.8142 14.8344 12.6427 14.6594C12.4712 14.4844 12.2587 14.3969 12.0052 14.3969C11.7517 14.3969 11.5374 14.4826 11.3624 14.6541C11.1874 14.8256 11.0999 15.0381 11.0999 15.2916C11.0999 15.5451 11.1857 15.7594 11.3572 15.9344C11.5287 16.1094 11.7412 16.1969 11.9947 16.1969ZM11.9947 12.8969C12.2482 12.8969 12.4624 12.8111 12.6374 12.6396C12.8124 12.4681 12.8999 12.2556 12.8999 12.0021C12.8999 11.7486 12.8142 11.5344 12.6427 11.3594C12.4712 11.1844 12.2587 11.0969 12.0052 11.0969C11.7517 11.0969 11.5374 11.1826 11.3624 11.3541C11.1874 11.5256 11.0999 11.7381 11.0999 11.9916C11.0999 12.2451 11.1857 12.4594 11.3572 12.6344C11.5287 12.8094 11.7412 12.8969 11.9947 12.8969ZM11.9947 9.59687C12.2482 9.59687 12.4624 9.51113 12.6374 9.33963C12.8124 9.16813 12.8999 8.95563 12.8999 8.70213C12.8999 8.44863 12.8142 8.23437 12.6427 8.05937C12.4712 7.88437 12.2587 7.79687 12.0052 7.79687C11.7517 7.79687 11.5374 7.88262 11.3624 8.05412C11.1874 8.22562 11.0999 8.43812 11.0999 8.69162C11.0999 8.94512 11.1857 9.15937 11.3572 9.33437C11.5287 9.50937 11.7412 9.59687 11.9947 9.59687Z"
        fill="currentColor"
      />
    </g>
  </Icon>
);

export const ArrowRightIcon = (props: IconProps) => (
  <Icon viewBox="0 0 21 20" {...props}>
    <path
      d="M10.4987 16.6693L9.6237 15.7734L14.7695 10.6276H3.83203V9.3776H14.7695L9.6237 4.23177L10.4987 3.33594L17.1654 10.0026L10.4987 16.6693Z"
      fill="currentColor"
    />
  </Icon>
);

export const CloseIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      fill="currentColor"
    />
  </Icon>
);

export const CheckIconVoucher = (props: IconProps) => (
  <Icon viewBox="0 0 20 20" fill="none" {...props}>
    <mask
      id="mask0_7937_143895"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_7937_143895)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.1556 16.1797C2.48199 16.5061 2.87435 16.6693 3.33268 16.6693H16.666C17.1243 16.6693 17.5167 16.5061 17.8431 16.1797C18.1695 15.8533 18.3327 15.4609 18.3327 15.0026V12.1901C18.3327 12.0373 18.2841 11.9054 18.1868 11.7943C18.0896 11.6832 17.9646 11.6137 17.8118 11.5859C17.4785 11.4748 17.2042 11.2734 16.9889 10.9818C16.7737 10.6901 16.666 10.3637 16.666 10.0026C16.666 9.64149 16.7737 9.3151 16.9889 9.02344C17.2042 8.73177 17.4785 8.53038 17.8118 8.41927C17.9646 8.39149 18.0896 8.32205 18.1868 8.21094C18.2841 8.09983 18.3327 7.96788 18.3327 7.8151V5.0026C18.3327 4.54427 18.1695 4.15191 17.8431 3.82552C17.5167 3.49913 17.1243 3.33594 16.666 3.33594H3.33268C2.87435 3.33594 2.48199 3.49913 2.1556 3.82552C1.82921 4.15191 1.66602 4.54427 1.66602 5.0026V7.8151C1.66602 7.96788 1.71463 8.09983 1.81185 8.21094C1.90907 8.32205 2.03407 8.39149 2.18685 8.41927C2.52018 8.53038 2.79449 8.73177 3.00977 9.02344C3.22504 9.3151 3.33268 9.64149 3.33268 10.0026C3.33268 10.3637 3.22504 10.6901 3.00977 10.9818C2.79449 11.2734 2.52018 11.4748 2.18685 11.5859C2.03407 11.6137 1.90907 11.6832 1.81185 11.7943C1.71463 11.9054 1.66602 12.0373 1.66602 12.1901V15.0026C1.66602 15.4609 1.82921 15.8533 2.1556 16.1797ZM13.5535 6.53975L8.63688 11.4564L7.05355 9.87309C6.90077 9.72031 6.70633 9.64392 6.47021 9.64392C6.2341 9.64392 6.03966 9.72031 5.88688 9.87309C5.7341 10.0259 5.65771 10.2203 5.65771 10.4564C5.65771 10.6925 5.7341 10.887 5.88688 11.0398L8.05355 13.2064C8.22021 13.3731 8.41466 13.4564 8.63688 13.4564C8.8591 13.4564 9.05355 13.3731 9.22022 13.2064L14.7202 7.70642C14.873 7.55364 14.9494 7.3592 14.9494 7.12309C14.9494 6.88698 14.873 6.69253 14.7202 6.53975C14.5674 6.38698 14.373 6.31059 14.1369 6.31059C13.9008 6.31059 13.7063 6.38698 13.5535 6.53975Z"
        fill="#34C759"
      />
    </g>
  </Icon>
);
